import { useState, useEffect } from "react";

export const VendorWatermark = ({ user }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(t);
  }, []);

  const when = now.toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  const line1 = `${user.name || ""} · ${user.email}`;
  const line2 = `${when} · ${(user.id || "").slice(0, 8)}`;
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='460' height='300'><g transform='rotate(-24 230 150)' font-family='monospace' fill='rgba(255,255,255,0.045)'><text x='10' y='150' font-size='15'>${line1}</text><text x='10' y='172' font-size='13'>${line2}</text></g></svg>`;
  return (
    <div
      aria-hidden="true"
      data-testid="vendor-watermark"
      className="fixed inset-0 z-[60] pointer-events-none select-none"
      style={{ backgroundImage: `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`, backgroundRepeat: "repeat" }}
    />
  );
};
